import { render, staticRenderFns } from "./AdminGenericProductAttributesEditScreen.vue?vue&type=template&id=ea04df6c&scoped=true&"
import script from "./AdminGenericProductAttributesEditScreen.vue?vue&type=script&lang=js&"
export * from "./AdminGenericProductAttributesEditScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea04df6c",
  null
  
)

export default component.exports